// @flow

export const Model = {
  ['timestamp']: '',

  ['type']: '',

  ['flat.type']: '',
  ['flat.floor.flat']: 0,
  ['flat.floor.total']: 0,
  ['flat.space']: 5,
  ['flat.rooms']: 1,

  ['house.type']: '',
  ['house.space.indoor']: 0,
  ['house.space.outdoor']: 50,

  ['yearOfConstruction']: 1815,
  ['yearOfLastModernisation']: 2000,
  ['quality']: '',

  ['exteriorEquipment.balcony']: false,
  ['exteriorEquipment.terrace']: false,
  ['exteriorEquipment.parkingLot']: false,
  ['exteriorEquipment.garage']: false,
  ['exteriorEquipment.garden']: false,
  ['exteriorEquipment.solarSystem']: false,

  ['internalEquipment.attic']: false,
  ['internalEquipment.basement']: false,
  ['internalEquipment.elevator']: false,
  ['internalEquipment.fittedKitchen']: false,
  ['internalEquipment.parquet']: false,
  ['internalEquipment.fireplace']: false,

  ['specialFeatures']: '',
  ['use']: '',

  ['yearPurchase']: new Date().getFullYear() - 15,
  ['price']: 25000,

  ['purpose']: '',

  ['dateOfSell']: '',

  ['street']: '',
  ['streetNumber']: '',
  ['zip']: '',
  ['city']: '',

  ['person.title']: 'Herr',
  ['person.name']: '',
  ['person.phonenumber']: '',
  ['person.mail']: ''
};

export type StateType = {
  progress: number,
  currentQuestion: number
};

export const State: StateType = {
  progress: 0,
  currentQuestion: 26,
  Model
};

export const Questions = [
  // QUESTION 0
  {
    question: 'Welche <b>Immobilie</b> möchten Sie bewerten lassen?',
    skipable: 'false',
    answers: [{
        text: 'Haus bewerten',
        value: 'House',
        nextQuestion: 1,
        answerPath: 'type'
      },
      {
        text: 'Wohnung bewerten',
        value: 'Flat',
        nextQuestion: 12,
        answerPath: 'type'
      }
    ]
  },

  // House Path
  // QUESTION 1
  {
    question: 'Welche <b>Art von Haus</b> möchten Sie bewerten lassen?',
    skipable: 'false',
    answers: [{
        text: 'Bungalow',
        value: 'Bungalow',
        nextQuestion: 2,
        answerPath: 'house.type'
      },
      {
        text: 'Einfamilienhaus',
        value: 'Einfamilienhaus',
        nextQuestion: 2,
        answerPath: 'house.type'
      },
      {
        text: 'Mehrfamilienhaus',
        value: 'Mehrfamilienhaus',
        nextQuestion: 2,
        answerPath: 'house.type'
      },
      {
        text: 'Mittelreihenhaus',
        value: 'Mittelreihenhaus',
        nextQuestion: 2,
        answerPath: 'house.type'
      },
      {
        text: 'Reihenendhaus',
        value: 'Reihenendhaus',
        nextQuestion: 2,
        answerPath: 'house.type'
      },
      {
        text: 'Doppelhaushälfte',
        value: 'Doppelhaushälfte',
        nextQuestion: 2,
        answerPath: 'house.type'
      }
    ]
  },

  // QUESTION 2
  {
    question: 'Bitte wählen Sie <b>Wohn-</b> und <b>Grundstücksfläche.</b>',
    answers: [{
        text: 'Wohnfläche in m²',
        value: '',
        min: 0,
        max: 850,
        step: 5,
        nextQuestion: 3,
        answerPath: 'house.space.indoor'
      },
      {
        text: 'Grundstücksfläche in m²',
        value: '',
        min: 50,
        max: 3550,
        step: 50,
        nextQuestion: 3,
        answerPath: 'house.space.outdoor'
      }
    ]
  },
  // QUESTION 3
  {
    question: 'Wann wurde das Haus <b>gebaut</b> und zuletzt <b>modernisiert?</b>',
    answers: [{
        text: 'Baujahr',
        value: '',
        min: 1815,
        max: new Date().getFullYear(),
        nextQuestion: 4,
        answerPath: 'yearOfConstruction'
      },
      {
        text: 'Letzte Modernisierung',
        value: '',
        min: 2000,
        max: new Date().getFullYear(),
        nextQuestion: 4,
        answerPath: 'yearOfLastModernisation'
      }
    ]
  },

  // QUESTION 4
  {
    question: 'Bitte wählen Sie die <b>Qualität</b> Ihres Hauses.',
    skipable: 'false',

    answers: [{
        text: 'Einfach',
        value: 'Einfach',
        nextQuestion: 5,
        answerPath: 'quality'
      },
      {
        text: 'Normal',
        value: 'Normal',
        nextQuestion: 5,
        answerPath: 'quality'
      },
      {
        text: 'Gehoben',
        value: 'Gehoben',
        nextQuestion: 5,
        answerPath: 'quality'
      },
      {
        text: 'Luxus',
        value: 'Luxus',
        nextQuestion: 5,
        answerPath: 'quality'
      }
    ]
  },

  // QUESTION 5
  {
    question: 'Bitte wählen Sie die <b>äußeren Sondermerkmale</b> Ihres Hauses aus',
    skipable: 'true',
    answers: [{
        text: 'Balkon',
        value: 'Balkon',
        nextQuestion: 6,
        answerPath: 'exteriorEquipment.balcony'
      },
      {
        text: 'Terasse',
        value: 'Terasse',
        nextQuestion: 6,
        answerPath: 'exteriorEquipment.terrace'
      },
      {
        text: 'Garten',
        value: 'Garten',
        nextQuestion: 6,
        answerPath: 'exteriorEquipment.garden'
      },
      {
        text: 'Solaranlage',
        value: 'Solaranlage',
        nextQuestion: 6,
        answerPath: 'exteriorEquipment.solarSystem'
      },
      {
        text: 'Parkplatz',
        value: 'Parkplatz',
        nextQuestion: 6,
        answerPath: 'exteriorEquipment.parkingLot'
      },
      {
        text: 'Garagenplatz',
        value: 'Garagenplatz',
        nextQuestion: 6,
        answerPath: 'exteriorEquipment.garage'
      }
    ]
  },
  // QUESTION 6
  {
    question: 'Bitte wählen Sie <b>inneren Sondermerkmale</b> Ihres Hauses aus.',
    skipable: 'true',
    answers: [{
        text: 'Dachboden',
        value: 'Dachboden',
        nextQuestion: 7,
        answerPath: 'internalEquipment.attic'
      },
      {
        text: 'Keller',
        value: 'Keller',
        nextQuestion: 7,
        answerPath: 'internalEquipment.basement'
      },
      {
        text: 'Aufzug',
        value: 'Aufzug',
        nextQuestion: 7,
        answerPath: 'internalEquipment.elevator'
      },
      {
        text: 'Einbauküche',
        value: 'Einbauküche',
        nextQuestion: 7,
        answerPath: 'internalEquipment.fittedKitchen'
      },
      {
        text: 'Parkettboden',
        value: 'Parkettboden',
        nextQuestion: 7,
        answerPath: 'internalEquipment.parquet'
      },
      {
        text: 'Kamin',
        value: 'Kamin',
        nextQuestion: 7,
        answerPath: 'internalEquipment.fireplace'
      }
    ]
  },

  // QUESTION 7
  {
    question: 'Welche <b>weitere Ausstattung</b> hat Ihr Haus?',
    skipable: 'true',
    answers: [{
      text: 'z.B. Einbauküche, Smarthome ...',
      value: '',
      nextQuestion: 8,
      answerPath: 'specialFeatures'
    }]
  },

  // QUESTION 8
  {
    question: 'Wie wird Ihr Haus <b>aktuell genutzt?</b>',
    skipable: 'false',
    answers: [{
        text: 'Eigennutzung',
        value: 'Eigennutzung',
        nextQuestion: 9,
        answerPath: 'use'
      },
      {
        text: 'Vermietet',
        value: 'Vermietet',
        nextQuestion: 9,
        answerPath: 'use'
      },
      {
        text: 'Leerstehend',
        value: 'Leerstehend',
        nextQuestion: 9,
        answerPath: 'use'
      }
    ]
  },

  // QUESTION 9
  // TEXT CHANGE STOP
  {
    question: 'Haben Sie Ihr <b>Haus</b> erworben?',
    answers: [{
        text: 'Kauf-/Baudatum',
        value: '',
        min: new Date().getFullYear() - 15,
        max: new Date().getFullYear(),
        nextQuestion: 10,
        answerPath: 'yearPurchase'
      },
      {
        text: 'Kaufpreis in €',
        value: '',
        min: 25000,
        max: 2000000,
        step: 25000,
        nextQuestion: 10,
        answerPath: 'price'
      }
    ]
  },
  // QUESTION 10
  {
    question: '<b>Zu welchem Zweck</b> benötigen Sie die Immobilienbewertung?',
    skipable: 'false',
    answers: [{
        text: 'Immobilie verkaufen',
        value: 'Immobilie verkaufen',
        nextQuestion: 11,
        answerPath: 'purpose'
      },
      {
        text: 'Immobilie kaufen',
        value: 'Immobilie kaufen',
        nextQuestion: 25,
        answerPath: 'purpose'
      }
    ]
  },
  // QUESTION 11
  {
    question: 'Wann möchten Sie <b>Ihr Haus verkaufen</b>?',
    skipable: 'false',
    answers: [{
        text: 'Schnellstmöglich',
        value: 'Schnellstmöglich',
        nextQuestion: 24,
        answerPath: 'dateOfSell'
      },
      {
        text: 'In den nächsten 6 Monaten',
        value: 'In den nächsten 6 Monaten',
        nextQuestion: 24,
        answerPath: 'dateOfSell'
      },
      {
        text: 'In den nächsten 12 Monaten',
        value: 'In den nächsten 12 Monaten',
        nextQuestion: 24,
        answerPath: 'dateOfSell'
      },
      {
        text: 'In den nächsten 2 Jahren',
        value: 'In den nächsten 2 Jahren',
        nextQuestion: 25,
        answerPath: 'dateOfSell'
      },
      {
        text: 'Kein Verkauf geplant',
        value: 'Kein Verkauf geplant',
        nextQuestion: 25,
        answerPath: 'dateOfSell'
      },
      {
        text: 'Immobilie gehört mir nicht',
        value: 'Immobilie gehört mir nicht',
        nextQuestion: 25,
        answerPath: 'dateOfSell'
      }
    ]
  },

  // Flat Plath
  // QUESTION 12
  {
    question: 'Welche <b>Art von Wohnung</b> möchten Sie bewerten lassen?',
    skipable: 'false',
    answerPath: 'house.type',
    answers: [{
        text: 'Souterrain',
        value: 'Souterrain',
        nextQuestion: 13,
        answerPath: 'flat.type'
      },
      {
        text: 'Erdgeschoss',
        value: 'Erdgeschoss',
        nextQuestion: 13,
        answerPath: 'flat.type'
      },
      {
        text: 'Etagenwohnung',
        value: 'Etagenwohnung',
        nextQuestion: 13,
        answerPath: 'flat.type'
      },
      {
        text: 'Dachegeschoss',
        value: 'Dachegeschoss',
        nextQuestion: 13,
        answerPath: 'flat.type'
      },
      {
        text: 'Maisonette',
        value: 'Maisonette',
        nextQuestion: 13,
        answerPath: 'flat.type'
      },
      {
        text: 'Loft',
        value: 'Loft',
        nextQuestion: 13,
        answerPath: 'flat.type'
      }
    ]
  },
  // QUESTION 13
  {
    question: 'Wie <b>viele Etagen</b> hat das Gebäude insgesamt?',
    answers: [{
      text: 'Etagen im Gebäude',
      value: '',
      min: 0,
      max: 30,
      nextQuestion: 14,
      answerPath: 'flat.floor.total'
    }]
  },
  // QUESTION 14
  {
    question: 'Bitte wählen Sie <b>Wohnfläche</b> und die <b>Zimmeranzahl.</b>',
    answers: [{
        text: 'Wohnfläche in m²',
        value: '',
        min: 5,
        max: 850,
        nextQuestion: 15,
        answerPath: 'flat.space'
      },
      {
        text: 'Anzahl der Zimmer',
        value: '',
        min: 1,
        max: 5,
        step: 0.5,
        nextQuestion: 15,
        answerPath: 'flat.rooms'
      }
    ]
  },

  // QUESTION 15
  {
    question: 'Wann wurde die Wohnung <b>gebaut</b> und zuletzt <b>modernisiert?</b>',
    answers: [{
        text: 'Baujahr',
        value: '',
        min: 1815,
        max: new Date().getFullYear(),
        nextQuestion: 16,
        answerPath: 'yearOfConstruction'
      },
      {
        text: 'Letzte Modernisierung',
        value: '',
        min: 2000,
        max: new Date().getFullYear(),
        nextQuestion: 16,
        answerPath: 'yearOfLastModernisation'
      }
    ]
  },
  // QUESTION 16
  {
    question: 'Bitte wählen Sie die <b>Qualität</b> Ihrer Wohnung.',
    skipable: 'false',
    answers: [{
        text: 'Einfach',
        value: 'Einfach',
        nextQuestion: 17,
        answerPath: 'quality'
      },
      {
        text: 'Normal',
        value: 'Normal',
        nextQuestion: 17,
        answerPath: 'quality'
      },
      {
        text: 'Gehoben',
        value: 'Gehoben',
        nextQuestion: 17,
        answerPath: 'quality'
      },
      {
        text: 'Luxus',
        value: 'Luxus',
        nextQuestion: 17,
        answerPath: 'quality'
      }
    ]
  },
  // QUESTION 17
  {
    question: 'Bitte wählen Sie die <b>äußeren Sondermerkmale</b> Ihrer Wohnung aus',
    skipable: true,
    answers: [{
        text: 'Balkon',
        value: 'Balkon',
        nextQuestion: 18,
        answerPath: 'exteriorEquipment.balcony'
      },
      {
        text: 'Terasse',
        value: 'Terasse',
        nextQuestion: 18,
        answerPath: 'exteriorEquipment.terrace'
      },
      {
        text: 'Garten',
        value: 'Garten',
        nextQuestion: 18,
        answerPath: 'exteriorEquipment.garden'
      },
      {
        text: 'Solaranlage',
        value: 'Solaranlage',
        nextQuestion: 18,
        answerPath: 'exteriorEquipment.solarSystem'
      },
      {
        text: 'Parkettboden',
        value: 'Parkettboden',
        nextQuestion: 18,
        answerPath: 'exteriorEquipment.parkingLot'
      },
      {
        text: 'Garagenplatz',
        value: 'Garagenplatz',
        nextQuestion: 18,
        answerPath: 'exteriorEquipment.garage'
      }
    ]
  },

  // QUESTION 18
  {
    question: 'Bitte wählen Sie <b>inneren Sondermerkmale</b> Ihrer Wohnung aus.',
    skipable: true,
    answers: [{
        text: 'Dachboden',
        value: 'Dachboden',
        nextQuestion: 19,
        answerPath: 'internalEquipment.attic'
      },
      {
        text: 'Keller',
        value: 'Keller',
        nextQuestion: 19,
        answerPath: 'internalEquipment.basement'
      },
      {
        text: 'Aufzug',
        value: 'Aufzug',
        nextQuestion: 19,
        answerPath: 'internalEquipment.elevator'
      },
      {
        text: 'Einbauküche',
        value: 'Einbauküche',
        nextQuestion: 19,
        answerPath: 'internalEquipment.fittedKitchen'
      },
      {
        text: 'Parkettboden',
        value: 'Parkettboden',
        nextQuestion: 19,
        answerPath: 'internalEquipment.parquet'
      },
      {
        text: 'Kamin',
        value: 'Kamin',
        nextQuestion: 19,
        answerPath: 'internalEquipment.fireplace'
      }
    ]
  },

  // QUESTION 19
  {
    question: 'Welche <b>weitere Ausstattung</b> hat Ihre Wohnung?',
    skipable: 'true',
    answers: [{
      text: 'z.B. Einbauküche, Smarthome ...',
      value: '',
      nextQuestion: 20,
      answerPath: 'specialFeatures'
    }]
  },

  // QUESTION 20
  {
    question: 'Wie wird Ihre Wohnung <b>aktuell genutzt?</b>',
    skipable: 'false',
    answers: [{
        text: 'Eigennutzung',
        value: 'Eigennutzung',
        nextQuestion: 21,
        answerPath: 'use'
      },
      {
        text: 'Vermietet',
        value: 'Vermietet',
        nextQuestion: 21,
        answerPath: 'use'
      },
      {
        text: 'Leerstehend',
        value: 'Leerstehend',
        nextQuestion: 21,
        answerPath: 'use'
      }
    ]
  },

  // QUESTION 21
  {
    question: 'Haben Sie Ihre <b>Wohnung</b> erworben?',
    answers: [{
        text: 'Kauf-/Baudatum',
        value: '',
        min: new Date().getFullYear() - 15,
        max: new Date().getFullYear(),
        nextQuestion: 22,
        answerPath: 'yearPurchase'
      },
      {
        text: 'Kaufpreis in €',
        value: '',
        min: 25000,
        max: 2000000,
        step: 25000,
        nextQuestion: 22,
        answerPath: 'price'
      }
    ]
  },
  // QUESTION 22
  {
    question: '<b>Zu welchem Zweck</b> benötigen Sie die Immobilienbewertung?',
    skipable: 'false',
    answers: [{
        text: 'Immobilie verkaufen',
        value: 'Immobilie verkaufen',
        nextQuestion: 23,
        answerPath: 'purpose'
      },
      {
        text: 'Immobilie kaufen',
        value: 'Immobilie kaufen',
        nextQuestion: 25,
        answerPath: 'purpose'
      }
    ]
  },
  // QUESTION 23
  {
    question: 'Wann möchten Sie <b>Ihre Wohnung verkaufen</b>?',
    skipable: 'false',
    answers: [{
        text: 'Schnellstmöglich',
        value: 'Schnellstmöglich',
        nextQuestion: 24,
        answerPath: 'dateOfSell'
      },
      {
        text: 'In den nächsten 6 Monaten',
        value: 'In den nächsten 6 Monaten',
        nextQuestion: 24,
        answerPath: 'dateOfSell'
      },
      {
        text: 'In den nächsten 12 Monaten',
        value: 'In den nächsten 12 Monaten',
        nextQuestion: 24,
        answerPath: 'dateOfSell'
      },
      {
        text: 'In den nächsten 2 Jahren',
        value: 'In den nächsten 2 Jahren',
        nextQuestion: 25,
        answerPath: 'dateOfSell'
      },
      {
        text: 'Kein Verkauf geplant',
        value: 'Kein Verkauf geplant',
        nextQuestion: 25,
        answerPath: 'dateOfSell'
      },
      {
        text: 'Immobilie gehört mir nicht',
        value: 'Immobilie gehört mir nicht',
        nextQuestion: 25,
        answerPath: 'dateOfSell'
      }
    ]
  },
  // QUESTION 24
  {
    question: 'Bitte nennen Sie die <b>Postleitzahl</b> Ihrer Immobilie.',
    skipable: 'false',
    answers: [{
      text: 'PLZ Ihrer Immobilie',
      value: '',
      nextQuestion: 26,
      answerPath: 'zip'
    }]
  },

  // QUESTION 25
  // INTEGRATE GOOGLE MAPS HERE
  {
    question: 'Bitte geben Sie für die Bewertung die <b>Adresse</b> Ihrer Immobilie ein.'
  },
  // QUESTION 26
  {
    question: 'Ihre Bewertung wird erstellt. Wer soll die Bewertung erhalten?',
    skipable: 'false',
    answers: [{
        text: 'Anrede',
        value: '',
        element: 'select',
        options: [{
            value: 'mr',
            label: 'Herr'
          },
          {
            value: 'mrs',
            label: 'Frau'
          }
        ],
        nextQuestion: 24,
        answerPath: 'person.title'
      },
      {
        text: 'Name',
        value: '',
        element: 'input',
        type: 'text',
        nextQuestion: 24,
        answerPath: 'person.name'
      }
    ]
  },
  // QUESTION 26
  {
    question: 'Ihre Bewertung wird erstellt.',
  }
];



// WEBPACK FOOTER //
// ./src/assets/model.js